import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { EditSolidIcon } from '@dhl-ui/icons'
import { Body1, Body2, Box, Card, Grid, H6, IconButton } from '@dhl-ui/components'
import { links } from '~/AppRoutes'
import type { ReturnHub } from '~/modules/returnhubsccc/model'

type Props = {
  returnHub: ReturnHub
}

export const ReturnHubDetails = ({ returnHub }: Props) => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { t } = useTranslation()

  return (
    <Card>
      <Card.Header
        title={t('admin.returnHubPage.returnHubDetails.profile')}
        endNode={
          <IconButton
            aria-label="Return hub details"
            onClick={() => (id ? navigate(links.editReturnHubLink(id)) : null)}
          >
            <EditSolidIcon />
          </IconButton>
        }
      />
      <Card.Content>
        <Grid container direction="column">
          <Grid>
            <Box>
              <H6>{t('admin.returnHubPage.accountInformation')}</H6>
            </Box>
          </Grid>
          <Grid container direction="row">
            <Grid>
              <Box marginTop={2}>
                <Body2 variant="tertiary">{t('admin.returnHubPage.name')}</Body2>
                <Body1>{returnHub.name}</Body1>
              </Box>
            </Grid>
          </Grid>
          <Grid>
            <Box marginTop={2}>
              <H6>{t('admin.returnHubPage.addressInformation')}</H6>
            </Box>
          </Grid>
          <Grid container direction="row" justifyContent="center" alignItems="stretch">
            <Grid size={{ xs: 4 }}>
              <Box marginTop={2}>
                <Body2 variant="tertiary">{t('admin.returnHubPage.postalCode')}</Body2>
                <Body1>{returnHub.address.postalCode}</Body1>
              </Box>
            </Grid>
            <Grid size={{ xs: 4 }}>
              <Box marginTop={2}>
                <Body2 variant="tertiary">{t('admin.returnHubPage.number')}</Body2>
                <Body1>{returnHub.address.houseNumber}</Body1>
              </Box>
            </Grid>
            <Grid size={{ xs: 4 }}>
              <Box marginTop={2}>
                <Body2 variant="tertiary">{t('admin.returnHubPage.addition')}</Body2>
                <Body1>{returnHub.address.houseNumberSuffix}</Body1>
              </Box>
            </Grid>
            <Grid size={{ xs: 4 }}>
              <Box marginTop={2}>
                <Body2 variant="tertiary">{t('admin.returnHubPage.street')}</Body2>
                <Body1>{returnHub.address.street}</Body1>
              </Box>
            </Grid>
            <Grid size={{ xs: 4 }}>
              <Box marginTop={2}>
                <Body2 variant="tertiary">{t('admin.returnHubPage.city')}</Body2>
                <Body1>{returnHub.address.city}</Body1>
              </Box>
            </Grid>
            <Grid size={{ xs: 4 }}>
              <Box marginTop={2}>
                <Body2 variant="tertiary">{t('admin.returnHubPage.country')}</Body2>
                <Body1>{t(`inputs.destinationInput.country_${returnHub.address.countryCode}`)}</Body1>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Card.Content>
    </Card>
  )
}
